import { useWatch } from 'react-hook-form';

import { InviteEligibilityBanner } from './invite-eligibility-banner';
import { useInviteEligibilityCheck } from '../hooks/use-invite-eligibility-check';

export function InviteEligibilityApplicantNotice({ index }: { index: number }) {
  const { isFeatureEnabled, isStale, getApplicant } = useInviteEligibilityCheck();
  const formEmail = useWatch({ name: `applicants.${index}.email` }) as string | null | undefined;

  if (!isFeatureEnabled || isStale) {
    return null;
  }

  const applicant = getApplicant(index);
  if (!applicant || applicant.outcome === 'allow') {
    return null;
  }

  const email = applicant.email.trim() || formEmail?.trim() || '';
  if (!email) {
    return null;
  }

  return (
    <InviteEligibilityBanner
      outcome={applicant.outcome}
      email={email}
      totalMatches={applicant.total_matches}
      reason={applicant.reason}
    />
  );
}
